import { useQuery } from "@tanstack/react-query";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import { Jalur } from "@/types";
import api from "@/lib/axios";
import SkeletonTable from "@/components/SkeletonTable";

export interface JalurResponse {
  data: Jalur[];
}

const getSysBerkasPortofolio = async () => {
  const response = await api.get("/setting/berkas-portofolio/index", {
    withCredentials: true,
  });
  return response.data?.data;
};

export default function SettingBerkasPortofolio() {
  const { data, isPending } = useQuery({
    queryKey: ["listSysBerkasPortofolio"],
    queryFn: getSysBerkasPortofolio,
  });

  if (isPending) return <SkeletonTable />;

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  );
}
